'use strict';

var Reflux = require('@muzzylane/reflux');

var RegisterActions = require('../actions/RegisterActions'),
    ServerRequest = require('../actions/request'),
    ErrorConsts = require('../constants/error'),
    ForgeError = require('../util/error');
var SignInActions = require('../actions/sign_in_actions');

var initialized = false;
var action = {};
var error = null;
let userInfo = {}; //storage for "light" user info as retrieved by the RegisterActions.userInfo request (used only during user registration)

var RegisterStore = Reflux.createStore({
    listenables: [RegisterActions,SignInActions],
    init: function() {
        initialized = true;
    },

    resetState: function() {
        // initialized = false;
        // action = {};
        // error = null;
        userInfo = {};
    },

    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },

    getState: function() {
        return {
            initialized: initialized,
            userInfo: userInfo,
            action: action,
        }
    },

    emitStatus: function() {
        //console.log("template store: EMIT");
        this.trigger(this.getState());
        action = {};
        error = null;
    },

    onRegisterEmailCompleted: function(actionID, res) {
        //console.log("onRegisterEmailCompleted:", res);
        action = {};
        action.id = actionID;
        action.message = "Registration email sent."

        this.emitStatus();
    },

    onRegisterEmailFailed: function(actionID, err) {
        console.warn("onRegisterEmailFailed:", err);
        action = {};
        action.id = actionID;

        if(err.status){
            switch(err.status){
                case 409:
                case 422:
                    action.error = new ForgeError({message: ErrorConsts.EMAIL_ALREADY_REGISTERED});
                    break;
                case 400:
                    action.error = new ForgeError({message: ErrorConsts.EMAIL_INVALID, uiRefs: ["email1", "email2"]});
                    break;
                default:
                    action.error = new ForgeError({message: ErrorConsts.INTERNAL_GENERAL});
            }
        }
        else {
            action.error = err;
        }

        this.emitStatus();
    },

    onSignUpFailed: function(actionID, err) {
        console.warn("onSignUpFailed:", err);
        action = {};
        action.id = actionID;

        if(err.status){
            switch(err.status){
                case 409:
                case 422:
                    action.error = new ForgeError({message: ErrorConsts.EMAIL_ALREADY_REGISTERED});
                    break;
                case 400:
                    action.error = new ForgeError({message: ErrorConsts.EMAIL_INVALID, uiRefs: ["email1", "email2"]});
                    break;
                default:
                    action.error = new ForgeError({message: ErrorConsts.INTERNAL_GENERAL});
            }
        }
        else {
            action.error = err;
        }

        this.emitStatus();
    },

    onSignUpCompleted: function(actionID, res) {
        //console.log("onRegisterEmailCompleted:", res);
        action = {};
        action.id = actionID;
        action.message = "Registration email sent."

        this.emitStatus();
    },

    onRegisterCompleted: function(actionID, res) {
        // console.log("onRegisterCompleted ", actionID, res);
        action = {};
        action.id = actionID;

        this.emitStatus();
    },

    onRegisterFailed: function(actionID, err) {
        console.warn("onRegisterFailed ", actionID, err);
        action = { id: actionID };

        if (err.status) {
            switch (err.status) {
                case 409:
                    action.error = new ForgeError({ message: ErrorConsts.EMAIL_ALREADY_REGISTERED });
                    break;
                case 422:
                    action.error = new ForgeError({ message: ErrorConsts.REGISTRATION_EXPIRED });
                    break;
                case 404:
                    action.error = new ForgeError({ message: err.responseText || ErrorConsts.INTERNAL_GENERAL })
                    break;
                default:
                    action.error = new ForgeError({ message: ErrorConsts.INTERNAL_GENERAL });
            }
        }
        else {
            action.error = err;
        }

        this.emitStatus();
    },

    onUserInfoCompleted: function(actionId, res) {
        action = { id: actionId };
        userInfo = res;
        this.emitStatus();
    },

    onUserInfoFailed: function(actionId, err) {
        console.warn("onUserInfoFailed ", actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },
});

module.exports = RegisterStore;
